export const whereAmI = () => {
  switch (window.location.host) {
  case 'carrier-dev.arrivelogistics.com': return 'dev';
  case 'carrier-test.arrivelogistics.com': return 'test';
  case 'carrier-stg.arrivelogistics.com': return 'stg';
  case 'carrier.arrivelogistics.com': return 'prod';
  default: return 'na';
  }
};
